// ============================================
// AUTO SAMPLE - Prescription Beauty
// Toont gratis sample regel bij elke bestelling
// ============================================

(function() {
  const SAMPLE_IMAGE = 'https://cdn.shopify.com/s/files/1/0536/4616/4148/files/Free_sample_Prescription.png?v=1777456429';
  const SAMPLE_NAME = 'Hyaluronic Acid - Sachet';

  let isProcessing = false;
  let notificationTimeout = null;

  function showNotification(message) {
    if (notificationTimeout) {
      clearTimeout(notificationTimeout);
      notificationTimeout = null;
    }

    let notification = document.getElementById('sample-notification');

    if (!notification) {
      notification = document.createElement('div');
      notification.id = 'sample-notification';
      notification.style.cssText = `
        position: fixed;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
        background-color: #533042;
        color: #ffffff;
        padding: 16px 28px;
        border-radius: 50px;
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 1px;
        text-transform: uppercase;
        font-family: var(--font-button, inherit);
        z-index: 99999;
        box-shadow: 0 4px 24px rgba(83,48,66,0.25);
        opacity: 0;
        transition: opacity 0.4s ease;
        white-space: nowrap;
        pointer-events: none;
      `;
      document.body.appendChild(notification);
    }

    notification.innerHTML = message;
    requestAnimationFrame(() => { notification.style.opacity = '1'; });

    notificationTimeout = setTimeout(() => {
      notification.style.opacity = '0';
      setTimeout(() => { if (notification.parentNode) notification.remove(); }, 400);
      notificationTimeout = null;
    }, 10000);
  }

  async function getCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  async function setCartAttribute(hasSample) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { 'gratis_sample': hasSample ? 'true' : '' }
      })
    });
  }

  // Injecteer de sample regel direct in de DOM
  function injectSampleRow(show) {
    document.querySelectorAll('.sample-row').forEach(el => el.remove());

    if (!show) return;

    const html = `
      <li class="cart-item wt-cart__item sample-row">
        <picture class="wt-cart__item__thumb">
          <img src="${SAMPLE_IMAGE}" alt="${SAMPLE_NAME}" style="width:100%;height:100%;object-fit:cover;border-radius:8px;">
        </picture>
        <div class="wt-cart__item__body">
          <div class="wt-cart__item__data">
            <h2 class="wt-cart__item__name cart-item__name"><span class="wt-cart__item__link" style="font-family: var(--font-body-family), 'Neue Haas Unica', sans-serif;">${SAMPLE_NAME}</span></h2>
          </div>
          <div class="wt-cart__item__amount cart-page">
            <div class="item__details">
              <div style="width:80px;"></div>
            </div>
            <div class="wt-cart__item__price-wrapper">
              <span class="price price--end">€0,00</span>
            </div>
          </div>
        </div>
      </li>
    `;

    const drawerList = document.querySelector('#CartDrawer-CartItems .wt-cart__list');
    if (drawerList) {
      drawerList.insertAdjacentHTML('beforeend', html);
    }

    const pageList = document.querySelector('#main-cart-items .wt-cart__list');
    if (pageList) {
      pageList.insertAdjacentHTML('beforeend', html);
    }
  }

  function refreshAndInject(show) {
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
      injectSampleRow(show);
      setTimeout(() => injectSampleRow(show), 600);
    }, 300);
  }

  async function checkAndUpdateSample() {
    if (isProcessing) return;
    isProcessing = true;

    try {
      const cart = await getCart();
      const hasSample = cart.attributes && cart.attributes['gratis_sample'] === 'true';
      // Sample verschijnt zodra er íets in de cart zit
      const shouldHave = cart.item_count > 0;

      injectSampleRow(shouldHave);

      if (shouldHave && !hasSample) {
        await setCartAttribute(true);
        refreshAndInject(true);
        showNotification('Gratis sample toegevoegd!');
      } else if (!shouldHave && hasSample) {
        await setCartAttribute(false);
        refreshAndInject(false);
      }
    } finally {
      isProcessing = false;
    }
  }

  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const result = await originalFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    const isCartCall = url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update');

    if (isCartCall) {
      const clone = result.clone();
      clone.json().catch(() => {}).finally(() => {
        setTimeout(checkAndUpdateSample, 500);
      });
    }

    return result;
  };

  document.addEventListener('cart-drawer:refresh', () => {
    setTimeout(async () => {
      const cart = await getCart();
      const shouldHave = cart.item_count > 0;
      injectSampleRow(shouldHave);
    }, 700);
  });

  document.addEventListener('DOMContentLoaded', checkAndUpdateSample);

})();